"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BEFORE_PAYDAY_EMPTY_COPY = void 0;
exports.beforePaydayDueBy = beforePaydayDueBy;
/**
 * CALL-06 decision 4 (Paul, 2026-10-27): Upcoming's before-payday group. Its heading is
 * Home's HOME_TILE_BILLS_DUE_COPY with Home's figure; under it, the date the total runs to
 * and, when nothing falls before payday, one plain line. Shared so both apps say it the
 * same way (rule 17, agreed with web 2026-10-28).
 */
function beforePaydayDueBy(date) {
    const copy = `Due by ${date}`;
    return copy;
}
/** The group when no bill falls between today and payday. */
exports.BEFORE_PAYDAY_EMPTY_COPY = "Nothing due before payday.";
//# sourceMappingURL=beforePaydayCopy.js.map